import type { Banner } from "@/types";

export const banners: Banner[] = [
  {
    id: "banner-1",
    softwareId: "genshin",
    title: "原界幻想 5.4.0 全新版本上线",
    subtitle: "开放世界新地图「焰海」开启，限定角色与活动同步登场，立即体验元素策略之战。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20open%20world%20landscape%20with%20floating%20islands%20and%20glowing%20crystal%20light%2C%20cinematic%20wide%20banner%20illustration%2C%20rich%20teal%20and%20gold%20tones%2C%20dramatic%20atmosphere%2C%20high%20detail%20digital%20art&width=1600&height=640&seq=banner-genshin-01&orientation=landscape",
    tag: "重磅新游",
  },
  {
    id: "banner-2",
    softwareId: "honor-of-kings",
    title: "王者对决 9.2.10 赛季更新",
    subtitle: "新英雄「苍岚」登场，全新赛季奖励与段位继承上线，组队开黑即刻开战。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20battle%20arena%20with%20heroes%20and%20glowing%20energy%20effects%2C%20cinematic%20wide%20game%20banner%20illustration%2C%20gold%20and%20deep%20blue%20tones%2C%20dynamic%20action%20atmosphere%2C%20high%20detail%20digital%20art&width=1600&height=640&seq=banner-moba-01&orientation=landscape",
    tag: "版本更新",
  },
  {
    id: "banner-3",
    softwareId: "meituan",
    title: "美生活 12.9.4 生活节钜惠",
    subtitle: "外卖红包、到店团购与酒店出行多重福利叠加，一站式解决日常所需。",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20city%20lifestyle%20scene%20with%20delivery%20and%20travelling%20elements%2C%20friendly%20wide%20banner%20illustration%2C%20warm%20yellow%20and%20fresh%20green%20tones%2C%20clean%20flat%20style%2C%20high%20detail%20vector%20art&width=1600&height=640&seq=banner-life-01&orientation=landscape",
    tag: "限时优惠",
  },
];